import './progressBar.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ProgressBar = props => {
  const className = classNames({
    progressbar: true,
    [props.className]: props.className,
  });

  const value = props.value / (props.max - props.min);

  return (
    <div className={className}>
      <div className="progressbar-track">
        <div className="progressbar-value" style={{ width: `${value * 100}%` }} />
      </div>
      {props.label && <div className="progressbar-label">{props.label}</div>}
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  className: PropTypes.string,
};

ProgressBar.defaultProps = {
  min: 0,
  max: 100,
};

export default ProgressBar;
